module.exports = __webpack_public_path__ + "img/logo-1-zh.3705cc70.png";